import Typography from '../../../../components/Typography/Typography'
import { ReactComponent as HospitalIcon } from 'assets/svg/Hospital.svg'

export const EmptyState = () => {
  return (
    <div className="business-details-container__empty-state row justify-center">
      <div className="business-details-container__empty-state__wrapper column align-center gap-24">
        <HospitalIcon />
        <Typography.Headline6 className="mt-16">
          Nothing found.
        </Typography.Headline6>
      </div>
    </div>
  )
}
